// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/RelatoriosOS_ServicosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de /relatorios/relatorios_os/servicos (chamado NS 2026-0084).
 *
 * Lista já filtrada pelo filtro global (franquias + período). Os totais são
 * somados no front.
 */
import type { RelatoriosOS_ServicosRow } from './RelatoriosOS_ServicosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type RelatoriosOS_ServicosResponseDados = RelatoriosOS_ServicosRow[];

export type RelatoriosOS_ServicosResponse = ApiResponse<RelatoriosOS_ServicosResponseDados>;

registerResponseContract('RelatoriosOS_ServicosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      franquia_id:          { type: 'number',  required: true },
      franquia_nome:        { type: 'string',  required: true },
      tipo:                 { type: 'string',  required: true },
      servico_id:           { type: 'number',  required: false },
      servico_nome:         { type: 'string',  required: true },
      categoria_nome:       { type: 'string',  required: true },
      ordens:               { type: 'number',  required: true },
      quantidade:           { type: 'number',  required: true },
      quantidade_via_combo: { type: 'number',  required: false },
      valor:                { type: 'number',  required: true },
      valor_medio:          { type: 'number',  required: true },
    },
  },
})
